(function () {
  function initDeliveryLink() {
    document.querySelectorAll('[data-pdp-delivery-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('data-delivery-target');
        if (!targetId) return;

        var panel = document.getElementById(targetId);
        if (!panel) return;

        event.preventDefault();

        var details = panel.closest('details');
        if (details) {
          details.open = true;
        }

        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initSingleOpenAccordion() {
    document.querySelectorAll('[data-product-accordion]').forEach(function (list) {
      list.querySelectorAll('details[data-accordion-item]').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;

          list.querySelectorAll('details[data-accordion-item]').forEach(function (other) {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });
    });
  }

  function initFaqAccordion() {
    document.querySelectorAll('[data-product-faq]').forEach(function (list) {
      list.querySelectorAll('details[data-faq-item]').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;

          list.querySelectorAll('details[data-faq-item]').forEach(function (other) {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });
    });
  }

  function initStickyBar() {
    var stickyBar = document.querySelector('[data-product-sticky-bar]');
    var buyTarget = document.querySelector('[data-product-buy]');
    var mainForm = document.querySelector('.product-single__form');
    if (!stickyBar || !buyTarget || !mainForm) return;

    var mainQty = mainForm.querySelector('[name="quantity"]');
    var stickyQty = stickyBar.querySelector('[data-sticky-qty-input]');
    var stickyMinus = stickyBar.querySelector('[data-sticky-qty-minus]');
    var stickyPlus = stickyBar.querySelector('[data-sticky-qty-plus]');
    var stickyAtc = stickyBar.querySelector('[data-sticky-atc-btn]');
    var mainAtc = mainForm.querySelector('[type="submit"][name="add"]');

    function syncQtyFromMain() {
      if (mainQty && stickyQty) stickyQty.value = mainQty.value;
    }

    function syncQtyToMain() {
      if (mainQty && stickyQty) mainQty.value = stickyQty.value;
    }

    if (stickyMinus) {
      stickyMinus.addEventListener('click', function () {
        if (!stickyQty) return;
        stickyQty.value = Math.max(1, parseInt(stickyQty.value, 10) - 1);
        syncQtyToMain();
      });
    }

    if (stickyPlus) {
      stickyPlus.addEventListener('click', function () {
        if (!stickyQty) return;
        stickyQty.value = parseInt(stickyQty.value, 10) + 1;
        syncQtyToMain();
      });
    }

    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        syncQtyToMain();
        if (mainAtc) mainAtc.click();
      });
    }

    if (mainQty) {
      mainQty.addEventListener('change', syncQtyFromMain);
    }

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', !visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });

    observer.observe(buyTarget);
    syncQtyFromMain();
  }

  function initGloboIntegration() {
    var form = document.querySelector('.product-single__form');
    var mount = document.querySelector('[data-globo-mount]');
    var section = document.querySelector('[data-section-type="product-template"]');
    if (!form || !mount) return;

    var searchRoot = section || form;
    var globoSelector = [
      '.globo-swatch-product-detail',
      '.globo-product-options',
      '.globo-product-option',
      '#globo-product-options',
      '.globo_color_swatch_bundle_combo',
      '.globo_color_swatch_bundle_quantity_break'
    ].join(',');

    function globoNodeHasContent(node) {
      if (!node) return false;
      return !!node.querySelector('ul, .globo-product-option, .option-label, .globo-style--button, .globo-style--color, input, select, textarea');
    }

    function mergeGloboContainers() {
      var containers = mount.querySelectorAll('.globo-swatch-product-detail');
      if (containers.length <= 1) return;

      var target = containers[0];
      for (var i = 1; i < containers.length; i += 1) {
        while (containers[i].firstChild) {
          target.appendChild(containers[i].firstChild);
        }
        containers[i].remove();
      }
    }

    function moveGloboNodes() {
      searchRoot.querySelectorAll(globoSelector).forEach(function (node) {
        if (node === mount || mount.contains(node)) return;
        if (node.matches('[data-globo-mount]')) return;
        if (node.classList.contains('globo-swatch-product-detail') && !globoNodeHasContent(node)) return;

        var parentGlobo = node.parentElement && node.parentElement.closest(globoSelector);
        if (parentGlobo && parentGlobo !== node && !mount.contains(parentGlobo)) return;

        mount.appendChild(node);
      });

      mergeGloboContainers();

      if (globoNodeHasContent(mount)) {
        document.body.classList.add('has-globo-swatches');
      }
    }

    moveGloboNodes();
    [400, 1200, 2500, 4000].forEach(function (delay) {
      setTimeout(moveGloboNodes, delay);
    });

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(moveGloboNodes);
      observer.observe(searchRoot, { childList: true, subtree: true });
    }
  }

  function boot() {
    initDeliveryLink();
    initSingleOpenAccordion();
    initFaqAccordion();
    initStickyBar();
    initGloboIntegration();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
